import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate';
import * as Cookies from 'js-cookie';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({
    getState: (key) => Cookies.get(key),
    setState: (key, state) => Cookies.set(key, state, { expires: 3, secure: true })
  })],
  state: {
    user: JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_TOKEN)) || null,
    position: null,
    Sidebar_drawer: null,
    Customizer_drawer: false,
    SidebarColor: "#352fad", //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
    SidebarBg: "",
    navbarColor: "#352fad",
    setHorizontalLayout: false, // Horizontal layout
  },
  mutations: {
    SET_USER(state, payload) {
      state.user = payload
    },
    SET_POSITION(state, payload) {
      if (payload) {
        state.position = {
          latitude: payload.latitude,
          longitude: payload.longitude
        }
      }
      else state.position = null
    },
    SET_SIDEBAR_DRAWER(state, payload) {
      state.Sidebar_drawer = payload;
    },
    SET_CUSTOMIZER_DRAWER(state, payload) {
      state.Customizer_drawer = payload;
    },
    SET_SIDEBAR_COLOR(state, payload) {
      state.SidebarColor = payload;
    },
    SET_NAVBAR_COLOR(state, payload) {
      state.navbarColor = payload;
    },
    SET_LAYOUT(state, payload) {
      state.setHorizontalLayout = payload;
    },
  },
  actions: {
    LOGOUT({ commit }) {
      localStorage.removeItem(process.env.VUE_APP_USER_TOKEN)
      delete axios.defaults.headers.common['Authorization']
      commit('SET_USER', {})
      router.go('/')
    },
    SET_USER({ commit, dispatch }, payload) {
      if (!payload) dispatch('LOGOUT')
      axios.defaults.headers.common['Authorization'] = `Bearer ${payload.token}`
      commit('SET_USER', payload)
    },
  },
  getters: {
    GET_USER: state => state.user,
    GET_ROLE(state) {
      if (!state.user) return null
      return state.user.role
    },
    IS_SUPER_ROLE(state) {
      let superRole = (state.user.role == 'admin' || state.user.role == 'root') ? true : false
      return superRole
    },
    GET_VERSION() {
      return process.env.VUE_APP_VERSION ? `V.${process.env.VUE_APP_VERSION}` : "V.0"
    }
  },
});
